import { Box, Typography, styled, css } from '@mui/material';
import Mui from 'materials';

export const BluBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.lightBlue.o25,
  borderRadius: theme.spacing(2),
  gap: theme.spacing(3),
}));

export const ReadOnlyBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: 24,
  backgroundColor: '#E1E4E6',
  borderRadius: 8,
}));

export const OutlinedBox = styled(Box)(({ theme }) => ({
  border: 'solid black 1px',
  borderRadius: 8,
  padding: theme.spacing(4, 8),
  fontSize: 10,
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const OutlineText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  width: '50 vw',
  border: 'solid black 1px',
  borderRadius: theme.spacing(2, 2, 0, 0),
  whiteSpace: 'nowrap',
  textAlign: 'center',
  fontSize: 10,
  background: theme.palette.common.white,
  padding: theme.spacing(1, 3),
  transform: 'translateY(-50%)',
  top: '12px',
}));

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 4,
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));

export const BufferFill = styled(Box)(() => ({
  pt: 4,
  position: 'absolute',
  width: '100%',
  transformOrigin: 'bottom',
  transition: 'transform 0.3sease',
}));

export const BufferText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: theme.spacing(2, 4),
  fontSize: 10,
  textAlign: 'center',
}));

export const AccordionGroup = styled(Mui.AccordionGroup)(() => ({
  alignContent: 'flex-start',
  flexDirection: 'row',
  backgroundColor: '#E1E4E6',
  borderRadius: 8,

  width: '100%',
}));

export const Accordion = styled(Mui.Accordion)(() => ({
  background: 'transparent',
  width: '100%',
  padding: 16,
}));

export const GridWrapper = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.5fr) minmax(0, 1.5fr)',
  width: '100%',
  alignItems: 'center',
  justifyItems: 'start',
  pr: 4,
  paddingTop: 0,
}));


export const drawerOverflowStyle = css`
  .MuiDrawer-paper:has(.feed-inventory-log) {
    overflow-y: hidden;
  }
`;